import { IonCol, IonRow, useIonToast } from '@ionic/react';
import { useCallback, useEffect, useRef, useState } from 'react';

import ActionButton from '../../../../components/button/ActionButton';
import InputItem from '../../../../components/input/InputItem';
import { isWebView, passToWebView } from '../../../../library/Funcs';
import { UploadImagePostAction } from '../../../../redux/actions/Account';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';

interface Props {
    form: any,
    setForm: any,
    defaultImage: string
}

const NationalCardImage: React.FC<Props> = (props) => {
    const [toast, dismiss] = useIonToast();
    const nationalCardFileRef = useRef<HTMLInputElement>(null);

    const dispatch = useAppDispatch()
    const formUploadImage = useAppSelector(state => state.uploadNationalCard)
    const { form_loading, resp } = formUploadImage

    const nationalCardFileSelectHandler = async () => {
        if (isWebView()) {
            await passToWebView("requestCameraPermission", "");
        }

        nationalCardFileRef.current?.click();
    }

    const nationalCardChangeHandler = (e: any) => {
        let image = e.target.files[0];

        dispatch(UploadImagePostAction("national_card", image, "", "", "", ""));
    }

    useEffect(() => {
        const uploadDone = () => {
            if (resp != null && !form_loading) {
                if (resp.result) {
                    const form = {...props.form}
                    form.national_card.value = resp.national_card;
                    props.setForm(form);
                } else {
                    toast({ message: resp.message, duration: 2000, color: "danger" })
                }
            }
        }

        uploadDone();
    }, [form_loading])

    return <IonRow>
        <IonCol>
            <img className="national-card" src={props.form.national_card.value?.length == 0 ? props.defaultImage : props.form.national_card.value + '?' + new Date().getTime()} />

            <div className="upload-container">
                <ActionButton text="انتخاب تصویر کارت ملی" compact loading={form_loading} click={nationalCardFileSelectHandler} />
                
                <input type="file" accept=".jpg, .jpeg, .png" ref={nationalCardFileRef} onClick={(e: any) => e.target.value = null} onChange={nationalCardChangeHandler} />
                
                <InputItem name="national_card" type="hidden" label="" />
            </div>
        </IonCol>
    </IonRow>
}

export default NationalCardImage